/*
 * EverQuilts - product page conversion pack (27.10.2026)
 * Loaded by snippets/eq-cro-pdp.liquid (one line in snippets/buy-buttons.liquid).
 *
 * Works only on the main product section: product-info[id^="MainProduct-"].
 * Quick-add modals and featured-product sections are left alone.
 *
 * B. Size M preselected (01.11.2026 - replaces "Choose your size")
 *    Dawn preselects the first available variant (Black / S). Without a
 *    ?variant= in the URL, the page switches to size M of the preselected
 *    Style + Color by clicking that Size radio, so Dawn itself re-renders
 *    price, compare-at, -X% badge, the form's variant id, Shop Pay and the
 *    URL. M missing or sold out -> the available size closest to M (L, S,
 *    XL, ...). The price is painted with that variant right away so the S
 *    price does not flash. A ?variant= in the URL (ads, shared links) wins.
 *    The button is always the normal "Add to cart"; size is never blocked.
 *    Changing Style/Color keeps the checked size (Dawn sends all options).
 * A. Sticky Add to cart bar (phones, <= 749px) shown once the main button
 *    has scrolled above the screen (IntersectionObserver).
 * D. "Order today -> estimated delivery Mon D - Mon D": 4-9 business days
 *    from today in America/Los_Angeles (1-2 print + 3-7 transit), weekends
 *    and US federal holidays skipped.
 */
(function () {
  'use strict';
  if (window.eqCroPdp) return;
  window.eqCroPdp = true;

  var HINT_UNISEX = 'Unisex fit. Our most popular size: L. Between sizes? Size up for a relaxed fit.';
  var HINT_OTHER = 'Between sizes? Size up for a relaxed fit.';
  /* Distance from M decides the fallback size; ties go to the larger size. */
  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  var DEFAULT_SIZE = 'M';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  /* US federal holidays (observed dates) - carriers do not deliver. */
  var HOLIDAYS = [
    '2026-11-11', '2026-11-26', '2026-12-25',
    '2027-01-01', '2027-01-18', '2027-02-15', '2027-05-31', '2027-06-18',
    '2027-07-05', '2027-09-06', '2027-10-11', '2027-11-11', '2027-11-25', '2027-12-24',
    '2027-12-31'
  ];
  var ETA_MIN = 4;
  var ETA_MAX = 9;

  function money(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function addToCartText() {
    return (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
  }

  function soldOutText() {
    return (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
  }

  function setText(node, text) {
    if (node && node.textContent !== text) node.textContent = text;
  }

  /* ------------------------------------------------------------ data */

  function findIndex(names, re) {
    for (var i = 0; i < names.length; i++) {
      if (re.test(String(names[i]).trim())) return i;
    }
    return -1;
  }

  function readData(info) {
    var tag = info.querySelector('script[data-eq-cro-variants]');
    if (!tag) return null;
    try {
      var d = JSON.parse(tag.textContent);
      if (!d || !d.options || !d.variants) return null;
      d.options = d.options.map(function (o) {
        return typeof o === 'string' ? o : o && o.name ? o.name : String(o);
      });
      return d;
    } catch (e) {
      return null;
    }
  }

  /* Option name -> checked value, read from the live picker. */
  function selection(ctx) {
    var out = {};
    var picker = ctx.info.querySelector('variant-selects');
    if (picker) {
      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
        if (input.dataset.optionName) out[input.dataset.optionName.toLowerCase()] = input.value;
      });
      picker.querySelectorAll('select').forEach(function (select) {
        var m = (select.name || '').match(/options\[(.+)\]/);
        if (m) out[m[1].toLowerCase()] = select.value;
      });
    }
    return out;
  }

  function variantById(ctx, id) {
    if (!ctx.data || !id) return null;
    id = Number(id);
    for (var i = 0; i < ctx.data.variants.length; i++) {
      if (ctx.data.variants[i].id === id) return ctx.data.variants[i];
    }
    return null;
  }

  function hiddenVariant(ctx) {
    var form = document.getElementById('product-form-' + ctx.section);
    var input = form && form.querySelector('input[name="id"]');
    return variantById(ctx, input && input.value);
  }

  /* Variant matching what the shopper sees checked (falls back to the form). */
  function currentVariant(ctx) {
    if (!ctx.data) return null;
    var sel = selection(ctx);
    var names = ctx.data.options;
    for (var i = 0; i < ctx.data.variants.length; i++) {
      var v = ctx.data.variants[i];
      var ok = true;
      for (var j = 0; j < names.length; j++) {
        var want = sel[String(names[j]).toLowerCase()];
        if (want == null || v.o[j] !== want) {
          ok = false;
          break;
        }
      }
      if (ok) return v;
    }
    return hiddenVariant(ctx);
  }

  function valueOf(ctx, idx) {
    if (idx < 0 || !ctx.data) return '';
    var sel = selection(ctx);
    var name = String(ctx.data.options[idx]).toLowerCase();
    if (sel[name] != null) return sel[name];
    var v = hiddenVariant(ctx);
    return v ? v.o[idx] : '';
  }

  function sizeRank(value) {
    var i = SIZE_ORDER.indexOf(String(value).trim().toUpperCase());
    return i < 0 ? 99 : i;
  }

  /* Size M of the checked Style + Color; M missing or sold out -> the
     available size closest to M (ties: the larger size). null = leave Dawn's
     preselected variant alone (no sizes, nothing available). */
  function defaultVariant(ctx) {
    if (!ctx.data || ctx.sizeIdx < 0) return null;
    var style = valueOf(ctx, ctx.styleIdx);
    var color = valueOf(ctx, ctx.colorIdx);
    var target = sizeRank(DEFAULT_SIZE);
    var best = null;
    var bestScore = null;
    ctx.data.variants.forEach(function (v) {
      if (!v.a) return;
      if (ctx.styleIdx > -1 && v.o[ctx.styleIdx] !== style) return;
      if (ctx.colorIdx > -1 && v.o[ctx.colorIdx] !== color) return;
      var r = sizeRank(v.o[ctx.sizeIdx]);
      var score = r === 99 ? 1000 : Math.abs(r - target) * 2 + (r < target ? 1 : 0);
      if (bestScore === null || score < bestScore) {
        best = v;
        bestScore = score;
      }
    });
    return best;
  }

  function pct(v) {
    if (!v || !v.c || v.c <= v.p) return '';
    return '-' + Math.round(((v.c - v.p) * 100) / v.c) + '%';
  }

  /* Compare-at, badge and on-sale class follow variant v. Originals are
     kept so a later Dawn re-render (new nodes) is never fought. */
  function applySale(box, v) {
    var priceEl = box.querySelector('.price');
    if (!priceEl || !v) return;
    var onSale = !!(v.c && v.c > v.p);
    if (priceEl.dataset.eqSaleOrig == null) priceEl.dataset.eqSaleOrig = priceEl.classList.contains('price--on-sale') ? '1' : '0';
    priceEl.classList.toggle('price--on-sale', onSale);
    var s = box.querySelector('.price__sale s.price-item--regular');
    if (s && onSale) {
      if (s.dataset.eqOrig == null) s.dataset.eqOrig = s.textContent;
      if (s.textContent.trim() !== money(v.c)) s.textContent = money(v.c);
    }
    var badge = box.querySelector('.price__badge-sale');
    if (badge) {
      if (badge.dataset.eqOrig == null) badge.dataset.eqOrig = badge.textContent;
      var t = pct(v);
      if (badge.textContent.trim() !== t) badge.textContent = t;
    }
  }

  /* ------------------------------------------------------------ DOM refs */

  function submitButton(ctx) {
    return document.getElementById('ProductSubmitButton-' + ctx.section);
  }

  function sizeFieldset(ctx) {
    var input = ctx.info.querySelector('variant-selects input[type="radio"][data-option-name="' + ctx.sizeName + '"]');
    return input ? input.closest('fieldset') : null;
  }

  /* ------------------------------------------------------------ B: size */

  function ensureHint(ctx) {
    var fs = sizeFieldset(ctx);
    if (!fs) return;
    var style = valueOf(ctx, ctx.styleIdx);
    var text = /v-?neck|ladies|women/i.test(style) ? HINT_OTHER : HINT_UNISEX;
    var hint = fs.querySelector('.eq-size-hint');
    if (!hint) {
      hint = document.createElement('p');
      hint.className = 'eq-size-hint';
      fs.appendChild(hint);
    }
    setText(hint, text);
  }

  /* Price, compare-at and badge of variant v, painted before Dawn's own
     re-render arrives (which then replaces these nodes with the same values). */
  function paintPrice(ctx, v) {
    var box = document.getElementById('price-' + ctx.section);
    if (!box || !v) return;
    box.querySelectorAll('.price__sale .price-item--last, .price__regular .price-item--regular').forEach(function (n) {
      if (n.textContent.trim() !== money(v.p)) n.textContent = money(v.p);
    });
    applySale(box, v);
  }

  /* No ?variant= in the URL: switch to size M (or the closest available). */
  function preselectSize(ctx) {
    if (!ctx.useSize || /[?&]variant=\d+/.test(window.location.search)) return;
    var v = defaultVariant(ctx);
    if (!v) return;
    var size = v.o[ctx.sizeIdx];
    var fs = sizeFieldset(ctx);
    if (!fs) return;
    var radio = null;
    fs.querySelectorAll('input[type="radio"]').forEach(function (r) {
      if (!radio && r.value === size) radio = r;
    });
    if (!radio || radio.checked) return;
    paintPrice(ctx, v);
    var go = function () {
      if (!radio.isConnected || radio.checked) return;
      radio.click();
    };
    if (window.customElements && customElements.whenDefined) {
      Promise.all([customElements.whenDefined('variant-selects'), customElements.whenDefined('product-info')]).then(go, go);
    } else {
      go();
    }
  }

  function apply(ctx) {
    if (ctx.useSize) ensureHint(ctx);
    updateSticky(ctx);
  }

  /* ------------------------------------------------------------ A: sticky */

  function buildSticky(ctx) {
    var btn = submitButton(ctx);
    if (!btn || !('IntersectionObserver' in window)) return;

    var bar = document.createElement('div');
    bar.className = 'eq-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="eq-sticky-atc__info">' +
      '<span class="eq-sticky-atc__opts"></span>' +
      '<span class="eq-sticky-atc__price"></span>' +
      '</div>' +
      '<button type="button" class="eq-sticky-atc__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);
    ctx.bar = bar;

    try {
      var cs = window.getComputedStyle(btn);
      var bg = cs.backgroundColor;
      if (bg && bg !== 'transparent' && !/rgba\(\s*0,\s*0,\s*0,\s*0\s*\)/.test(bg)) {
        bar.style.setProperty('--eq-sticky-bg', bg);
        bar.style.setProperty('--eq-sticky-fg', cs.color);
      }
    } catch (e) {
      /* fall back to the CSS defaults (#68337D / white) */
    }

    bar.querySelector('.eq-sticky-atc__btn').addEventListener('click', function () {
      var main = submitButton(ctx);
      if (main && !main.disabled && main.getAttribute('aria-disabled') !== 'true') main.click();
    });

    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      setPast(ctx, !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(btn);

    /* Backup for browsers that deliver IntersectionObserver late: a cheap,
       throttled position check on scroll. */
    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        setTimeout(function () {
          ticking = false;
          var b = submitButton(ctx);
          if (b) setPast(ctx, b.getBoundingClientRect().bottom < 0);
        }, 120);
      },
      { passive: true }
    );
  }

  function setPast(ctx, past) {
    if (ctx.pastAtc === past) return;
    ctx.pastAtc = past;
    updateSticky(ctx);
  }

  function updateSticky(ctx) {
    var bar = ctx.bar;
    if (!bar) return;
    var show = !!ctx.pastAtc;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('eq-sticky-on', show);
    var button = bar.querySelector('.eq-sticky-atc__btn');
    button.tabIndex = show ? 0 : -1;

    var v = currentVariant(ctx);
    var parts = [valueOf(ctx, ctx.styleIdx), valueOf(ctx, ctx.colorIdx)];
    if (ctx.sizeIdx > -1) parts.push(valueOf(ctx, ctx.sizeIdx));
    setText(bar.querySelector('.eq-sticky-atc__opts'), parts.filter(Boolean).join(' · '));

    var price = '';
    if (v) {
      price = money(v.p);
    } else {
      var node = document.querySelector('#price-' + ctx.section + ' .price-item--last');
      price = node ? node.textContent.trim() : '';
    }
    setText(bar.querySelector('.eq-sticky-atc__price'), price);

    var soldOut = !!(v && !v.a);
    setText(button, soldOut ? soldOutText() : addToCartText());
    button.disabled = soldOut;
  }

  /* ------------------------------------------------------------ D: ETA */

  function laToday() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Los_Angeles',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) {
        o[p.type] = p.value;
      });
      return new Date(Date.UTC(Number(o.year), Number(o.month) - 1, Number(o.day)));
    } catch (e) {
      var n = new Date();
      return new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()));
    }
  }

  function iso(d) {
    return d.toISOString().slice(0, 10);
  }

  function addBusinessDays(start, n) {
    var d = new Date(start.getTime());
    var added = 0;
    while (added < n) {
      d.setUTCDate(d.getUTCDate() + 1);
      var w = d.getUTCDay();
      if (w !== 0 && w !== 6 && HOLIDAYS.indexOf(iso(d)) === -1) added++;
    }
    return d;
  }

  function fmt(d) {
    return MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate();
  }

  function deliveryLine(ctx) {
    if (ctx.info.querySelector('.eq-eta')) return;
    var price = document.getElementById('price-' + ctx.section);
    if (!price) return;
    var container = price.closest('.product__info-container');
    var anchor = price;
    if (container) {
      while (anchor.parentElement && anchor.parentElement !== container) anchor = anchor.parentElement;
      if (anchor.parentElement !== container) anchor = price;
    }
    /* Stay below the price block's own extras: tax/shipping note, installments. */
    var next = anchor.nextElementSibling;
    while (next && (next.matches('.product__tax') || next.querySelector('form.installment'))) {
      anchor = next;
      next = anchor.nextElementSibling;
    }
    var today = laToday();
    var from = addBusinessDays(today, ETA_MIN);
    var to = addBusinessDays(today, ETA_MAX);
    var p = document.createElement('p');
    p.className = 'eq-eta';
    p.innerHTML =
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18"/></svg>' +
      '<span>Order today → estimated delivery <strong></strong></span>';
    p.querySelector('strong').textContent = fmt(from) + ' – ' + fmt(to);
    anchor.parentNode.insertBefore(p, anchor.nextSibling);
  }

  /* ------------------------------------------------------------ wiring */

  var contexts = {};

  function init(info) {
    if (info.__eqCro) return;
    var section = info.dataset.section;
    if (!section) return;
    var data = readData(info);
    var names = data ? data.options : [];
    var ctx = {
      info: info,
      section: section,
      data: data,
      styleIdx: findIndex(names, /style/i), /* "Style" or "Pick your style" */
      colorIdx: findIndex(names, /^colou?r$/i),
      sizeIdx: findIndex(names, /^size$/i),
      chosen: true, /* always true now; read by eq-bundle-builder.js / eq-pdp-redesign.js */
      useSize: false,
      pastAtc: false,
      bar: null
    };
    ctx.sizeName = ctx.sizeIdx > -1 ? names[ctx.sizeIdx] : 'Size';
    if (ctx.sizeIdx > -1 && data) {
      var sizes = {};
      data.variants.forEach(function (v) {
        sizes[v.o[ctx.sizeIdx]] = true;
      });
      if (Object.keys(sizes).length > 1 && sizeFieldset(ctx)) {
        ctx.useSize = true;
      }
    }
    info.__eqCro = ctx;
    contexts[section] = ctx;

    deliveryLine(ctx);
    buildSticky(ctx);
    apply(ctx);
    preselectSize(ctx);

    /* Dawn re-renders the picker and the price on every option change. */
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        apply(ctx);
      }, 30);
    }).observe(info, { childList: true, subtree: true });
  }

  function start() {
    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(init);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var id = evt && evt.data && evt.data.sectionId;
        if (id && contexts[id]) apply(contexts[id]);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
